import structureTypes from 'common/constants/structureTypes'
import { OldVideoInterface } from 'common/types/entities/OldEntityInterface'
import ServerPage from 'src/shared/types/server-page-interface'
import { migrateVideo } from './migrateVideo'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  try {
    const entities = Object.values(page.content.entities).reduce(
      (prev, entity) => {
        if (entity.type === structureTypes.VIDEO) {
          isChanged = true
        }

        return {
          ...prev,
          [entity.id]:
            entity.type === structureTypes.VIDEO
              ? migrateVideo(entity as OldVideoInterface)
              : entity,
        }
      },
      {},
    )
    return [
      {
        ...page,
        content: {
          ...page.content,
          entities,
        },
      },
      isChanged,
    ]
  } catch (e) {
    console.log(`--error--`, e, page.id)

    return [page, false]
  }
}
